import React, { useState } from 'react';
import "../../css/devices.css";
import equipmentsAXData from '../../assets/deviceAx.json';
import equipmentsACNData from '../../assets/deviceAcs.json';

const Devices = () => {
  const [activeTab, setActiveTab] = useState('ax');
  const [searchTerm, setSearchTerm] = useState('');
  const [equipmentsAX] = useState(equipmentsAXData);
  const [equipmentsACN] = useState(equipmentsACNData);

  const filteredEquipments = (equipments) => {
    return equipments.filter(equipment =>
      equipment.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const renderEquipments = (equipments) => {
    return filteredEquipments(equipments).map(equipment => (
      <div key={equipment.id} className="device-card">
        <div className="device-card-content">
          <div className="device-image-container">
            <img src={equipment.imageUrl} alt={equipment.name} className="device-image" />
          </div>
          <div className="device-info-container">
            <h3>{equipment.name}</h3>
            <p>{equipment.wifi}</p>
            <div className="device-buttons">
              <button
                className="btn-select"
                onClick={() => window.location.href = equipment.selectUrl}
              >
                Selecionar
              </button>
              <button
                className="btn-intelbras"
                onClick={() => window.location.href = equipment.intelUrl}
              >
                site Intelbras
              </button>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const getIndicatorPosition = () => {
    return activeTab === 'ax' ? 'translateX(0%)' : 'translateX(100%)';
  };

  return (
    <div className="devices-container">
      <div className="devices-search-bar">
        <h3>Selecione o equipamento</h3>
        <input
          type="text"
          placeholder="Buscar..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      <div className="devices-header">
        <h2
          className={`tab-title ${activeTab === 'ax' ? 'active' : ''}`}
          onClick={() => setActiveTab('ax')}
        >
          Equipamentos AX
        </h2>
        <h2
          className={`tab-title ${activeTab === 'acn' ? 'active' : ''}`}
          onClick={() => setActiveTab('acn')}
        >
          Equipamentos ACs / N
        </h2>
        <div
          className="tab-indicator-none"
        />

        <div
          className="tab-indicator"
          style={{ transform: getIndicatorPosition() }}
        />
      </div>

      <div className="devices-content">
        {activeTab === 'ax' && renderEquipments(equipmentsAX)}
        {activeTab === 'acn' && renderEquipments(equipmentsACN)}
      </div>
    </div>
  );
};

export default Devices;
